import { environment } from '@environment/environment';
import { ITask } from '@shared/interfaces/task.interface';
import { ILocation } from '@shared/interfaces/location.interface';
import { IUser } from '@shared/interfaces/user.interface';
import { Location } from '@shared/models/location.model';
import { User } from '@shared/models/user.model';
import { IAsset } from '@shared/interfaces/asset.interface';
import { IIssue } from '@shared/interfaces/issue.interface';
import { IQRCode } from '@shared/interfaces/qrcode.interface';
import { IChecklist } from '@shared/interfaces/checklist.interface';
import { ICompany } from '@shared/interfaces/company.interface';
import { IPicture } from '@shared/interfaces/picture.interface';

export class Issue implements IIssue {
  readonly id: string;
  readonly Id?: string;
  readonly label: string;
  readonly status?: string;
  readonly priority?: string;
  readonly comment: string;
  readonly isDeleted: boolean;
  readonly createdAt: Date;
  readonly questionId: string;
  readonly subLocation: Partial<ILocation>;
  readonly parentLocation: Partial<ILocation>;
  readonly createdBy: Partial<IUser>;
  readonly qrcode?: Partial<IQRCode>;
  readonly checklist: Partial<IChecklist>;
  readonly company: Partial<ICompany>;
  readonly pictures?: Partial<IPicture[]>;


  constructor(partial: Partial<IAsset>) {
    Object.assign(this, {
      ...partial,
      parentLocation:
        partial?.parentLocation !== null &&
          typeof partial?.parentLocation === 'object'
          ? new Location(partial.parentLocation)
          : partial?.parentLocation,
      subLocation:
        partial?.subLocation !== null &&
          typeof partial?.subLocation === 'object'
          ? new Location(partial.subLocation)
          : partial?.subLocation,
    });
  }

  get pillsPriority(): any {
    let label;
    let className;

    switch (this.priority) {
      case 'MEDIUM':
        label = 'Medium';
        className = 'ohq-badge-warning';
        break;

      case 'HIGH':
        label = 'High';
        className = 'ohq-badge-danger';
        break;

      case 'LOW':
      default:
        label = 'Low';
        className = 'ohq-badge-light text-dark';
        break;
    }

    return {
      label,
      class: className
    };
  }

  get getStatus(): any {
    let label;
    let className;

    switch (this.status) {
      case 'OPEN':
        label = 'OPEN';
        className = 'ohq-badge-light text-white open-badge';
        break;
      case 'COMPLETED':
        label = 'COMPLETED';
        className = 'ohq-badge-success';
        break;
      case 'ON_HOLD':
        label = 'ON HOLD';
        className = 'ohq-badge-warning';
        break;
      case 'CLOSED':
        label = 'CLOSED';
        className = 'ohq-badge-light text-white background-dark';
        break;
      case 'IN_PROGRESS':
        label = 'IN PROGRESS';
        className = 'ohq-badge-light blue-status';
        break;
      default:
        label = 'OPEN';
        className = 'ohq-badge-light text-dark';
        break;
    }

    return {
      label,
      class: className
    };
  }
}

